var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appView)?_c('v-app',[_c('v-content',[_c('router-view')],1),_c('v-footer',{staticClass:"blue darken-1",attrs:{"app":"","dark":""}},[_c('div',[_vm._v(_vm._s(_vm.$moment().format("YYYY"))+" — v. 1.0.0")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }